import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFeedback } from '../../utils/feedback';
import { duplicateTransportRoute } from './api/transportRoutesApi';
import { getTransportErrorMessage, isBlockingTransportError } from './transportErrorMessages';
import { withTransportReturnContext } from './transportReturnContext';

export function useDuplicateTransport(returnOrderId?: string) {
  const navigate = useNavigate();
  const { t } = useTranslation(['transport']);
  const feedback = useFeedback();
  const inFlight = useRef(false);
  const [duplicating, setDuplicating] = useState(false);

  const duplicate = async (sourceId: string) => {
    if (inFlight.current) return;
    inFlight.current = true;
    setDuplicating(true);
    try {
      const copy = await duplicateTransportRoute(sourceId);
      feedback.success(t('transport:duplicate.success', { number: copy.routeNumber }));
      navigate(withTransportReturnContext(`/app/transports/${copy.id}`, returnOrderId));
    } catch (error) {
      feedback.error(getTransportErrorMessage(error, t, 'transport:duplicate.error'), {
        sticky: isBlockingTransportError(error),
      });
    } finally {
      inFlight.current = false;
      setDuplicating(false);
    }
  };

  return { duplicate, duplicating };
}
